<ng-container *ngIf="locationSearchResults">
  <app-esri-map
    class="full"
    [locations]="locationSearchResults"
    [visibleLayers]="locationTypeSet"
    [selectedIslandName]="firstIslandSearchResult"
  ></app-esri-map>
</ng-container>
